import * as React from "react"

export const BlockText = ({text}: {text: string}) => {
    const split = text.split(' ')
    
    return <>
      {split.map((s: string, i:number) => <span key={i}>{s}</span>)}
    </>
}
  